import slide1 from "../assets/images/home/carousel/capella_savaria_1.jpg";
import slide2 from "../assets/images/home/carousel/capezzuto_2.jpg";
import slide3 from "../assets/images/home/carousel/evelyn_glennie_3.jpg";
import slide4 from "../assets/images/home/carousel/goldscheider_4.jpg";
import slide5 from "../assets/images/home/carousel/guarrera_5.jpg";
import slide6 from "../assets/images/home/carousel/jean_rondeau_6.jpg";
import slide7 from "../assets/images/home/carousel/koelner_akademie_7.jpg";
import slide8 from "../assets/images/home/carousel/la_venexiana_8.jpg";
import slide9 from "../assets/images/home/carousel/la_venexiana_9.jpg";
import slide10 from "../assets/images/home/carousel/la_venexiana_teatri_10.jpg";
import slide11 from "../assets/images/home/carousel/mayumi_kanagawa_11.jpg";
import slide12 from "../assets/images/home/carousel/nevermind_12.jpg";
import slide13 from "../assets/images/home/carousel/odhecaton_13.jpg";
import slide14 from "../assets/images/home/carousel/omodernt_14.jpg";
import slide15 from "../assets/images/home/carousel/scherzi_musicali_15.jpg";
import slide16 from "../assets/images/home/carousel/soqquadro_italiano_16.jpg";
import slide17 from "../assets/images/home/carousel/ticciati_17.jpg";

export const carouselImages = [
    slide1, slide2, slide3, slide4, slide5, slide6, slide7, slide8,
    slide9, slide10, slide11, slide12, slide13, slide14, slide15,
    slide16, slide17
];